import axios from 'axios'
import router from '../../router'

const state = {
  documents: []
}

const getters = {
  getDocuments (state) {
    return state.documents
  }
}

const mutations = {
  setDocuments (state, payload) {
    state.documents = payload
  }
}

const actions = {
  apiDocuments (context, payload) {
    if (sessionStorage.getItem('token') != null) {
      axios.defaults.headers.common['Authorization'] = sessionStorage.getItem('token')
      axios.post('/api/member/doc/getDocument', payload)
        .then((response) => {
          // console.log(response.data)
          if (response.data.length > 0) {
            context.commit('setDocuments', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          // alert(error.response.data.message)
          if (error.response.status === 403) {
            // sessionStorage.removeItem('token')
            alert('세션 만료 또는 잘못된 접근 입니다.')
            router.push('/')
          }
        })
    } else {
      axios.post('/api/doc/getDocument', payload)
        .then((response) => {
          // console.log(response.data)
          if (response.data.length > 0) {
            context.commit('setDocuments', response.data)
          } else {
            alert('검색 값이 존재하지 않습니다.')
          }
        })
        .catch((error) => {
          alert(error.response.data.message)
        })
    }
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/document.js